export enum DepartmentFeatures {
  OpenBankingStatementReport = 'OpenBankingStatementReport',
  JointApplication = 'JointApplication',
  AccountsOnDemandRefresh = 'AccountsOnDemandRefresh',
  CategorySpotlight = 'CategorySpotlight',
  WorkReport = 'WorkReport',
  WorkReportDataViewer = 'WorkReportDataViewer',
  OpenBanking = 'OpenBanking',
  JointApplicationsMultipleDepartmentReference = 'JointApplications.MultipleDepartmentReference',
  PortalCustomers = 'PortalCustomers',
  CoverageChecker = 'WorkReport.CoverageChecker',
  PepsAndSanctions = 'PepsAndSanctionsAffordabilityPortal',
  IdDocVerification = 'IdDocVerificationPortal',
  IdDocVerificationPassport = 'IdDocVerificationPassport',
  CreditReportPortalDirect = 'CreditReportPortalDirect',
  MonthlyOpenBankingStatement = 'MonthlyOpenBankingStatement',
  StandardFinancialStatement = 'StandardFinancialStatement',
  CoreOpenBanking = 'CoreOpenBanking',
  OBReviewTransactions = 'OBReviewTransactions',
  EnableCAISEnhancements = 'EnableCAISEnhancements',
}
